import { render, staticRenderFns } from "./mobileEditPlate.vue?vue&type=template&id=ba8ccd28&scoped=true&"
import script from "./mobileEditPlate.vue?vue&type=script&lang=js&"
export * from "./mobileEditPlate.vue?vue&type=script&lang=js&"
import style0 from "./mobileEditPlate.vue?vue&type=style&index=0&id=ba8ccd28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8ccd28",
  null
  
)

export default component.exports